goog.module('yext.storm.routesDEPRECATED');
goog.module.declareLegacyNamespace();

// DO NOT ADD NEW goog.exportSymbol CALLS TO THIS FILE.

const routes = goog.require('yext.storm.routes');

exports = routes;

// Used in /src/com/yext/subscriptions/public/js/chooseLocation.js
goog.exportSymbol('DO_NOT_USE.locationEditUrl', routes.LocationEdit.view);
goog.exportSymbol('DO_NOT_USE.Subscriptions.getChooseLocationDropdown', routes.Subscriptions.getChooseLocationDropdown);
goog.exportSymbol('DO_NOT_USE.Subscriptions.previewAddServices', routes.Subscriptions.previewAddServices);
goog.exportSymbol('DO_NOT_USE.Subscriptions.previewRemoveServices', routes.Subscriptions.previewRemoveServices);

// Used in /src/com/yext/subscriptions/public/js/chooseVoltronLocation.js
goog.exportSymbol('DO_NOT_USE.Subscriptions.voltronAddCheckout', routes.Subscriptions.voltronAddCheckout);
goog.exportSymbol('DO_NOT_USE.Subscriptions.voltronRemoveCheckout', routes.Subscriptions.voltronRemoveCheckout);
goog.exportSymbol('DO_NOT_USE.Subscriptions.duplicateCheck', routes.Subscriptions.duplicateCheck);
goog.exportSymbol('DO_NOT_USE.Subscriptions.getChooseVoltronLocationDropdown', routes.Subscriptions.getChooseVoltronLocationDropdown);
goog.exportSymbol('DO_NOT_USE.Subscriptions.updateVoltronLocations', routes.Subscriptions.updateVoltronLocations);
